import React from 'react'
import PropTypes from 'prop-types'

const CardGrid = ({ children }) => (
  <div className="CardGrid">
    {children}
  </div>
)

CardGrid.propTypes = {
  children: PropTypes.node.isRequired,
}

export default CardGrid
